import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {NgxTranslationsModule} from '@ngx-translations/translations.module';

import {NgxNotificationOptions} from '@ngx-notifications/notifications.interface';

import {NgxNotificationsList} from '@ngx-notifications/notifications-list/notifications-list.component';
import {NgxNotificationsItem} from '@ngx-notifications/notifications-item/notifications-item.component';

@NgModule({
    imports: [CommonModule, NgxTranslationsModule],
    declarations: [NgxNotificationsList, NgxNotificationsItem],
    exports: [NgxNotificationsList]
})
export class NgxNotificationsModule {

    static forRoot(options: NgxNotificationOptions = {}) {
        return {
            ngModule: NgxNotificationsModule,
            providers: [
                {provide: NgxNotificationOptions, useValue: options}
            ]
        };
    }

}
